import { render, staticRenderFns } from "./ClientPayment.vue?vue&type=template&id=689f88c8&"
import script from "./ClientPayment.vue?vue&type=script&lang=js&"
export * from "./ClientPayment.vue?vue&type=script&lang=js&"
import style0 from "./ClientPayment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports